import { Url, URLS } from '@wix/da-url';
import { ModalType } from '../Modals/redux/types';
var submitMenuItems = [
    {
        type: 'deviation',
        label: 'siteHeader.deviation',
        link: Url.buildFromPath(URLS.SUBMIT),
        showDaProtect: true,
        svg: 'il29_-_deviation_v3.svg', // IL6.2
    },
    {
        type: 'status',
        label: 'siteHeader.statusUpdate',
        verificationAction: 'submitstatus',
        modalType: ModalType.STATUS_UPDATE,
        svg: 'il30_-_status_update_v3.svg', // IL6.8
    },
    {
        type: 'journal',
        label: 'siteHeader.journal',
        verificationAction: 'submitjournal',
        modalType: ModalType.JOURNAL,
        svg: 'il31_-_journal_v3.svg', // IL6.3
    },
    {
        type: 'literature',
        label: 'siteHeader.literature',
        modalType: ModalType.LITERATURE,
        svg: 'il32_-_literature_v3.svg', // IL6.4
    },
    {
        type: 'commission',
        label: 'siteHeader.commission',
        verificationAction: 'submitcommission',
        modalType: ModalType.COMMISSION,
        modalOptions: {
            params: { redirectOnSubmit: true },
        },
        svg: 'il62_-_commission_v3.svg', // IL6.1
    },
    {
        type: 'poll',
        label: 'siteHeader.poll',
        verificationAction: 'submitpoll',
        modalType: ModalType.POLL_EDIT,
        svg: 'il33_-_poll_v3.svg', // IL6.7
    },
    {
        type: 'tier',
        label: 'siteHeader.tier',
        link: URLS.ROOT,
        modalType: ModalType.TIER_EDIT,
        modalOptions: {
            wrapInModal: false,
        },
        isNew: true,
        svg: 'il6_9_-_tip_jar.svg', // IL6.9
    },
    {
        type: 'dreamup',
        label: 'siteHeader.dreamup',
        link: Url.dreamupLink(),
        isNew: true,
    },
];
export var desktopSubmitMenuItems = submitMenuItems;
// mobile has fewer items in different order
export var mobileSubmitMenuItems = [
    'deviation',
    'status',
    'poll',
    'commission',
    'dreamup',
].map(function (type) { return submitMenuItems.find(function (item) { return item.type === type; }); });
export var submitButtonMenuItem = {
    type: 'submitbutton',
    link: Url.buildFromPath(URLS.SUBMIT),
};
//# sourceMappingURL=constants.js.map